module.exports = __webpack_public_path__ + "9538b32a6f2a08908d94395d32787c9a.svg";